import { toast } from "react-toastify";

export type TTextNotificationType = "error" | "info" | "success" | "warning";

export const triggerTextNotification = ({
  text,
  type,
}: {
  text?: string;
  type: TTextNotificationType;
}) => {
  switch (type) {
    case "error":
      toast.error(`${text}`);
      break;
    case "info":
      toast.info(`${text}`);
      break;
    case "success":
      toast.success(`${text}`);
      break;
    case "warning":
      toast.warning(`${text}`);
      break;
  }
};
